import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const subjectOptions = [
    { value: 'booking', label: 'Booking Inquiry' },
    { value: 'modification', label: 'Booking Modification' },
    { value: 'cancellation', label: 'Cancellation Request' },
    { value: 'complaint', label: 'Complaint' },
    { value: 'feedback', label: 'Feedback' },
    { value: 'corporate', label: 'Corporate Booking' },
    { value: 'other', label: 'Other' }
  ];

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubjectChange = (value) => {
    setFormData(prev => ({ ...prev, subject: value }));
    if (errors?.subject) {
      setErrors(prev => ({ ...prev, subject: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.name?.trim()) newErrors.name = 'Name is required';
    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/?.test(formData?.email)) {
      newErrors.email = 'Invalid email format';
    }
    if (!formData?.phone?.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/?.test(formData?.phone)) {
      newErrors.phone = 'Phone number must be 10 digits';
    }
    if (!formData?.subject) newErrors.subject = 'Please select a subject';
    if (!formData?.message?.trim()) newErrors.message = 'Message is required';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const newErrors = validateForm();
    
    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    setTimeout(() => {
      alert('Thank you for contacting us! We will respond within 24 hours.');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <Input
        label="Full Name"
        type="text"
        name="name"
        placeholder="Enter your full name"
        value={formData?.name}
        onChange={handleChange}
        error={errors?.name}
        required
      />
      <Input
        label="Email Address"
        type="email"
        name="email"
        placeholder="your.email@example.com"
        value={formData?.email}
        onChange={handleChange}
        error={errors?.email}
        required
      />
      <Input
        label="Phone Number"
        type="tel"
        name="phone"
        placeholder="10-digit mobile number"
        value={formData?.phone}
        onChange={handleChange}
        error={errors?.phone}
        required
      />
      <Select
        label="Subject"
        placeholder="Select inquiry type"
        options={subjectOptions}
        value={formData?.subject}
        onChange={handleSubjectChange}
        error={errors?.subject}
        required
      />
      <div className="space-y-2">
        <label className="block text-sm font-medium text-foreground">
          Message <span className="text-error">*</span>
        </label>
        <textarea
          name="message"
          rows="6"
          placeholder="Describe your inquiry in detail..."
          value={formData?.message}
          onChange={handleChange}
          className={`w-full px-4 py-3 rounded-lg border ${
            errors?.message ? 'border-error' : 'border-input'
          } bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all duration-200 resize-none`}
        />
        {errors?.message && (
          <p className="text-sm text-error mt-1">{errors?.message}</p>
        )}
      </div>
      <Button
        type="submit"
        variant="default"
        size="lg"
        loading={isSubmitting}
        iconName="Send"
        iconPosition="right"
        fullWidth
        className="bg-action hover:bg-action/90"
      >
        {isSubmitting ? 'Sending...' : 'Send Message'}
      </Button>
    </form>
  );
};

export default ContactForm;